/**
 * Private modules
 */
const {
  createQueryComponent,
  customerId,
  objectId,
  percent,
  systemGameTypeId,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

module.exports = {
  getCustomerDealerFightsBySystemGameTypeId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameTypeId,
        },
        required: [
          'customerId',
          'systemGameTypeId',
        ],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  updateCustomerDealerFightsBySystemGameTypeId: {
    properties: {
      body: {
        properties: {
          elements: {
            items: {
              properties: {
                objectId,
                percent,
              },
              required: [
                'objectId',
                'percent',
              ],
              type: 'object',
            },
            minItems: 1,
            type: 'array',
            uniqueItems: true,
          },
        },
        required: ['elements'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameTypeId,
        },
        required: [
          'customerId',
          'systemGameTypeId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
